import { createFileRoute } from '@tanstack/react-router';

import { Route as CompanyPageRoute } from './route';
import CompanyOverview from '@/modules/companies/pages/CompanyOverview';

export const Route = createFileRoute(
  '/_authenticated/_system/_company/company/',
)({
  head: () => ({
    meta: [{ title: 'Visão Geral da Empresa' }],
  }),
  component: function CompanyOverviewPage() {
    const company = CompanyPageRoute.useLoaderData();

    return <CompanyOverview company={company} />;
  },
});
